module.exports = __webpack_public_path__ + "img/glove-icon.cd899fcb.png";